export default __webpack_public_path__ + "static/angryipscanner-ec0028156aeaf5e6b797c2e74d930011.png";